// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__2mq7q"};